export default "__VITE_ASSET__a_1KO2iV__"